import React, { useEffect, useState } from 'react';
const buyers = [{
  name: 'Martín G.',
  province: 'Buenos Aires'
}, {
  name: 'Lucas R.',
  province: 'CABA'
}, {
  name: 'Diego F.',
  province: 'Córdoba'
}, {
  name: 'Federico M.',
  province: 'Santa Fe'
}, {
  name: 'Javier S.',
  province: 'Mendoza'
}, {
  name: 'Sebastián L.',
  province: 'Tucumán'
}, {
  name: 'Andrés P.',
  province: 'Salta'
}, {
  name: 'Nicolás A.',
  province: 'Entre Ríos'
}, {
  name: 'Matías C.',
  province: 'Neuquén'
}, {
  name: 'Gonzalo B.',
  province: 'Río Negro'
}, {
  name: 'Pablo H.',
  province: 'Chubut'
}, {
  name: 'Ezequiel V.',
  province: 'Misiones'
}, {
  name: 'Hernán D.',
  province: 'Corrientes'
}, {
  name: 'Cristian O.',
  province: 'Chaco'
}, {
  name: 'Leandro T.',
  province: 'Formosa'
}, {
  name: 'Maximiliano Q.',
  province: 'Jujuy'
}, {
  name: 'Iván Z.',
  province: 'San Juan'
}, {
  name: 'Rodrigo E.',
  province: 'San Luis'
}, {
  name: 'Emiliano N.',
  province: 'La Pampa'
}, {
  name: 'Damián U.',
  province: 'La Rioja'
}, {
  name: 'Tomás I.',
  province: 'Catamarca'
}, {
  name: 'Franco K.',
  province: 'Santiago del Estero'
}, {
  name: 'Alejandro J.',
  province: 'Tierra del Fuego'
}, {
  name: 'Bruno W.',
  province: 'Santa Cruz'
}];
const minutesAgoOptions = ['hace 1 min', 'hace 2 min', 'hace 4 min', 'hace 6 min', 'hace 8 min', 'hace 11 min'];
export function PurchasePopup() {
  const [current, setCurrent] = useState<{
    name: string;
    province: string;
    time: string;
  } | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showOne = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const time = minutesAgoOptions[Math.floor(Math.random() * minutesAgoOptions.length)];
      setCurrent({
        ...buyer,
        time
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const firstTimer = setTimeout(showOne, 4000);
    const interval = setInterval(showOne, 15000);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  if (!current) return null;
  return <div role="status" aria-live="polite" className={`fixed bottom-4 left-4 z-50 max-w-[300px] transition-all duration-500 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-173">
      <div className="flex items-start gap-3 bg-[#141414] border border-brand-red/40 rounded-lg shadow-[0_10px_40px_rgba(0,0,0,0.7),0_0_30px_rgba(204,0,0,0.25)] p-3 font-opensans" data-id="element-174">
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-gradient-to-br from-brand-red to-brand-red-dark flex items-center justify-center text-white text-base" data-id="element-175">
          ✓
        </div>
        <div className="flex-1 min-w-0" data-id="element-176">
          <div className="text-brand-white text-[11px] font-bold leading-tight" data-id="element-177">
            {current.name}{' '}
            <span className="text-brand-gold font-normal" data-id="element-178">
              de {current.province}
            </span>
          </div>
          <div className="text-brand-white/80 text-[10px] mt-0.5 leading-tight" data-id="element-179">
            acaba de comprar{' '}
            <span className="text-brand-red font-semibold" data-id="element-180">
              El Código del Control
            </span>
          </div>
          <div className="text-brand-white/50 text-[9px] mt-1 flex items-center gap-1" data-id="element-181">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block animate-pulse" data-id="element-182" />
            {current.time} · Compra verificada
          </div>
        </div>
        <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="flex-shrink-0 text-brand-white/40 hover:text-brand-white text-sm leading-none" data-id="element-183">
          ×
        </button>
      </div>
    </div>;
}